import type { Template } from "@/types";

export const LA_04_H3_V1: Template[] = [
    {
        id: "la-04-h3v1-01",
        name: "LA 01 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 180, y: 42, width: 317, height: 459, rotation: 0, imageRotation: 0 },
            { id: "2", x: 889, y: 42, width: 251, height: 149, rotation: 0, imageRotation: 0 },
            { id: "3", x: 889, y: 198, width: 251, height: 149, rotation: 0, imageRotation: 0 },
            { id: "4", x: 889, y: 354, width: 251, height: 148, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-02",
        name: "LA 02 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 177, y: 39, width: 322, height: 463, rotation: 0, imageRotation: 0 },
            { id: "2", x: 781, y: 228, width: 466, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 781, y: 40, width: 230, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 40, width: 229, height: 180, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-03",
        name: "LA 03 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 38, y: 40, width: 323, height: 459, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1096, y: 40, width: 218, height: 148, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1096, y: 197, width: 218, height: 147, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1096, y: 353, width: 218, height: 147, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-04",
        name: "LA 04 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 129, y: 41, width: 419, height: 296, rotation: 0, imageRotation: 0 },
            { id: "2", x: 129, y: 345, width: 206, height: 153, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 345, width: 206, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 855, y: 42, width: 317, height: 457, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-5",
        name: "LA 05 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 83, y: 74, width: 510, height: 395, rotation: 0, imageRotation: 0 },
            { id: "2", x: 750, y: 74, width: 272, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 276, width: 272, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1030, y: 74, width: 251, height: 395, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-06",
        name: "LA 06 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 213, width: 383, height: 283, rotation: 0, imageRotation: 0 },
            { id: "2", x: 390, y: 213, width: 383, height: 283, rotation: 0, imageRotation: 0 },
            { id: "3", x: 781, y: 213, width: 184, height: 283, rotation: 0, imageRotation: 0 },
            { id: "4", x: 972, y: 213, width: 386, height: 283, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-07",
        name: "LA 07 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 67, y: 133, width: 343, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 418, y: 133, width: 343, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 768, y: 133, width: 343, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1119, y: 133, width: 167, height: 276, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-08",
        name: "LA 08 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 38, y: 36, width: 312, height: 231, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 275, width: 312, height: 230, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 36, width: 649, height: 469, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1015, y: 36, width: 299, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-09",
        name: "LA 09 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 39, y: 36, width: 312, height: 231, rotation: 0, imageRotation: 0 },
            { id: "2", x: 39, y: 275, width: 312, height: 230, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 36, width: 300, height: 469, rotation: 0, imageRotation: 0 },
            { id: "4", x: 665, y: 36, width: 649, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-10",
        name: "LA 10 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 35, width: 339, height: 231, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 274, width: 339, height: 231, rotation: 0, imageRotation: 0 },
            { id: "3", x: 347, y: 35, width: 705, height: 470, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1060, y: 35, width: 292, height: 470, rotation: 0, imageRotation: 0 }
        ],
    }
];
